/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreBanner
 * Alfapeople -Customisation object -For Stor selection page
 */

import React, { Component } from 'react';

export interface IPlayRollIn {
  image?: string;
  description?: string;
  heading?: string;
}

/**
 *
 * StoreBanner component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */
export class PlayRollIn extends Component {
  private readonly playRollIn: IPlayRollIn = {
    image:
      'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD1UrO',
    heading: 'get the play rollin’',
    description:
      'DIY activities starring all their faves! These showstoppers add a whole lot more play to the toys they already have.',
  };

  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-lg-12 col-md-12 '>
            <div className='play-table'>
              <a className='play-table-link' href='/diy-activities'>
                {this.playRollIn.heading}
              </a>
              <p>{this.playRollIn.description}</p>
              <a href='/printables' role='button'>
                <img
                  className='img-responsive'
                  src={this.playRollIn.image}
                  alt={this.playRollIn.heading}
                />
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default PlayRollIn;
